export const AUTH = "AUTH";
export const LOGOUT = "LOGOUT";
export const SUBSCRIBE = "SUBSCRIBE";

export const STARTLOADING = "STARTLOADING";
export const ENDLOADING = "ENDLOADING";

export const GETSUBSCRIPTIONS = "GETSUBSCRIPTIONS";
export const UPLOADVIDEO = "UPLOADVIDEO";
export const GETVIDEOS = "GETVIDEOS";
export const GETVIDEO = "GETVIDEO";
export const GETBYSEARCH = "GETBYSEARCH";
export const LIKEVIDEO = "LIKEVIDEO";
export const DISLIKEVIDEO = "DISLIKEVIDEO";